import React from 'react'
import "../recent_news/RecentNews.css"
import ReusableRecentNews from '../organic9-reusable/ReusableRecentNews'
import { Container, Row } from 'react-bootstrap'
const RecentNews = () => {
  return (
    <>
     <section id="recent_news">
      <Container>
        <h1>Recent News</h1>
        <Row className='pt-5' style={{rowGap:'20px'}}>
          <ReusableRecentNews/>
          <ReusableRecentNews />
          <ReusableRecentNews />
        </Row>
      </Container>
     </section>
    </>
  )
}

export default RecentNews